/**
 * AbstractPopupMediator.js
 * Created on 12-okt-2015
 *
 *
 * @author Reinier Feijen for Ranj
 **/

import AbstractMediator from "./AbstractMediator";
import NavigateEvent from "../navigation/NavigateEvent";
import AnimationFactory from "../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";

export default class AbstractPopupMediator extends AbstractMediator {
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, appModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, appModel);
    }

    initialize() {
        super.initialize();

        if (this._target.closeButton) {
            this._closeButton = this.createButton(this._target.closeButton, this.handleCloseClick.bind(this));
        }
    }

    handleCloseClick(evt) {
        this.close();
    }

    /**
     * @param {*} payload Data to send as arguments in callback
     */
    close(payload = null) {
        const options = new AnimationOptions(0, 500, createjs.Ease.quadIn);
        let commandEvent = new NavigateEvent(NavigateEvent.CLOSE_POP_UP_REQUEST, null, this._target, undefined, undefined, undefined, undefined, AnimationFactory.FADE_OUT, options);
        this.dispatch(commandEvent.type, { data: commandEvent });

        const onClose = this._target.onClose;
        if (onClose != null) {
            onClose(payload);
        }
    }
}